import { useEffect, useState } from 'react';

import { useAdminApi } from '../../Admin/hooks/useAdminApi';

/**
 * Mapa `courseid → título` para exibir o produto do cupom pelo nome.
 * Busca todas as páginas de cursos; se falhar, o mapa fica vazio e a tabela
 * cai para o id cru — nunca bloqueia a lista de cupons.
 */
export const useCourseTitles = () => {
  const { fetchCourses } = useAdminApi();
  const [titles, setTitles] = useState<Record<string, string>>({});

  useEffect(() => {
    let active = true;

    const load = async () => {
      try {
        const first = await fetchCourses(0);
        const pages = first.data.pages ?? 0;
        const rest = await Promise.all(
          Array.from({ length: pages }, (_, i) => fetchCourses(i + 1).catch(() => null)),
        );

        const map: Record<string, string> = {};
        [first, ...rest].forEach(response =>
          (response?.data.courses ?? []).forEach(course => {
            map[course.courseid] = course.title;
          }),
        );
        if (active) setTitles(map);
      } catch {
        // Sem nomes: a tabela mostra o id do produto.
      }
    };

    load();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return titles;
};
